export default "__VITE_ASSET__L_bT$Grf__"